import { createFileRoute } from '@tanstack/react-router';
import { RecipeEditor } from '../features/recipes/RecipeEditor.tsx';

export const Route = createFileRoute('/recipes/new')({ component: () => <RecipeEditor /> });
